import { render, staticRenderFns } from "./FTManualReview.vue?vue&type=template&id=2db4d2d4&"
import script from "./FTManualReview.vue?vue&type=script&lang=js&"
export * from "./FTManualReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports